import { Container, Divider, Grid, Stack } from "@mui/material";
import { ReactElement } from "react";
import { TitleView } from "./TitleView";

interface props {
  title: string;
  titleLayout?: ReactElement;
  titleLayoutAlignItems?: "start" | "center";
  titleLayoutDirection?: "row" | "column";
  titleSize?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  layout: ReactElement;
  isLayoutFullWidthInSmallerScreens?: boolean;
  alignItems?: "start" | "center" | "end";
  hasDivider?: boolean;
  isLayoutLonger?: boolean;
}

export const HeaderView: React.FC<props> = ({
  title,
  titleLayout,
  titleLayoutAlignItems,
  titleLayoutDirection,
  layout,
  isLayoutFullWidthInSmallerScreens = true,
  alignItems,
  titleSize = "h4",
  hasDivider = true,
  isLayoutLonger = false,
}: props) => {
  return (
    <Stack>
      <Container maxWidth={false} sx={{ p: 2 }}>
        <Grid
          container
          spacing={2}
          alignItems={alignItems ? alignItems : "center"}
        >
          <Grid
            size={{
              xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              md: 6,
              lg: 4,
              xl: isLayoutLonger ? 2 : 3,
            }}
          >
            <Stack
              direction={titleLayoutDirection ? titleLayoutDirection : "row"}
              alignItems={
                titleLayoutAlignItems ? titleLayoutAlignItems : "center"
              }
              spacing={1}
            >
              <TitleView title={title} size={titleSize} />
              {titleLayout}
            </Stack>
          </Grid>
          <Grid size={{ xs: 0, xl: isLayoutLonger ? 2 : 3 }} />
          <Grid size={{ xs: 0, lg: 4, xl: isLayoutLonger ? 2 : 3 }} />
          <Grid
            size={{
              xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              md: 6,
              lg: 4,
              xl: isLayoutLonger ? 6 : 3,
            }}
          >
            {layout}
          </Grid>
        </Grid>
      </Container>
      {hasDivider && <Divider />}
    </Stack>
  );
};
